import { Head, Link } from '@inertiajs/react'
import Form from './form'
import type { CollectSessionType, DeviceOptionType, UserOptionType, AreaOptionType } from './types'

interface NewProps {
  collect_session: CollectSessionType
  devices: DeviceOptionType[]
  users: UserOptionType[]
  areas: AreaOptionType[]
}

export default function New({ collect_session, devices, users, areas }: NewProps) {
  return (
    <>
      <Head title="New collect session" />

      <div className="mx-auto md:w-2/3 w-full px-8 pt-8">
        <h1 className="font-bold text-4xl">New collect session</h1>

        <Form
          collect_session={collect_session}
          devices={devices}
          users={users}
          areas={areas}
          method="post"
          action="/system/collect_sessions"
          submitText="Create Collect session"
        />

        <Link
          href="/collect_sessions"
          className="ml-2 rounded-lg py-3 px-5 bg-gray-100 inline-block font-medium"
        >
          Back to collect sessions
        </Link>
      </div>
    </>
  )
}
